import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    marginTop: "20px",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  paper: {
    padding: "20px",
    border: "1px solid #E8E9EA",
  },
  description: {
    marginTop: "8px",
    marginBottom: "8px",
  },
  descriptionHeading: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 800,
  },
  apps: {
    gap: theme.spacing(5),
    marginBottom: theme.spacing(2.5),
  },
  app: {
    width: "100%",
    border: "1px solid #E8E9EA",
    padding: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(2.5),
  },
  appIcon: {
    width: "50px",
    height: "50px",
  },
  appName: {
    fontWeight: 800,
    marginBottom: theme.spacing(0.5),
  },
  helpLink: {
    color: theme.palette.blue.main,
    marginTop: theme.spacing(0.5),
  },
}));
